export enum AuditLogDescriptions {
    PAYMENT_MANUAL_CREATE= 'Payment marked as paid manually.',
    PAYMENT_MULTIPLE_MANUAL_CREATE= 'Multiple payments marked as paid manually.',
    VOUCHER_MANUAL_CREATE = 'Voucher created manually.',
    WINNER_ITEM_CANCELLED = 'Winner item cancelled.',
}
